import { render } from "./modal-add-bank.vue?vue&type=template&id=05dfe1f9&scoped=true&ts=true"
import script from "./modal-add-bank.vue?vue&type=script&lang=ts"
export * from "./modal-add-bank.vue?vue&type=script&lang=ts"

import "./modal-add-bank.vue?vue&type=style&index=0&id=05dfe1f9&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05dfe1f9"]])

export default __exports__